import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { StoreCoverage } from '../../../models/storecoverage';
import { Router } from '@angular/router';
import { MessageService } from '../../../services/message.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { UserRoleServiceService } from '../../../../shared/services/user-role-service.service';
import { UnsavedChangesService } from '../../../../unsaved-changes.service';
import { StorageService } from '../../../../Common/services/storage.service';
import { ProjectService } from '../../../services/project.service';
import { RoleKey } from '../../../../Common/Constants/common.constants';
import { UserLogin } from '../../../../Common/models/user.login';
import moment from 'moment';

@Component({
  selector: 'app-add-edit-store-coverage',
  templateUrl: './add-edit-store-coverage.component.html',
  styleUrl: './add-edit-store-coverage.component.css'
})
export class AddEditStoreCoverageComponent {

  @Input() storeCoverageData?: StoreCoverage;
  @Input() originalStoreCoverage?: StoreCoverage;
  @Input() selectedAction: string = 'ADD';

  @Output() saveSuccess = new EventEmitter<void>();

  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;

  reportIconText: string = 'salesplanadhoc_wt';
  reportHeaderText: string = 'STORE COVERAGE';

  selectedCategories: any[] = [];
  public categoryList: any[] = [];
  public userCategoryList: any[] = [];
  vendorId?: string;
  uInfo: UserLogin | null | undefined;

  allowedFileTypes: string = '';
  files: Array<{ name: string, base64: string }> = [];
  fileInputId: string = 'file-input';

  hasUnsaved: boolean = false;
  buttonText = 'SAVE';

  constructor(
    private projectService: ProjectService,
    private storageService: StorageService,
    private unsavedChangesService: UnsavedChangesService,
    private router: Router,
    private userRoleService: UserRoleServiceService,
    private ngxService: NgxUiLoaderService,
    private msgService: MessageService
  ) {

  }

  async ngOnInit() {

    this.unsavedChangesService.getUnsavedChanges$().subscribe((hasUnsaved) => {
      this.hasUnsaved = hasUnsaved;
    });

    if (this.userRoleService.role?.roleKey == RoleKey.ITAdmin) {
      this.router.navigate(['/unauthorized']);
      return;
    }

    this.getUserRoleInfo();
  }

  getUserRoleInfo() {
    let encodedVal = localStorage.getItem('UserRoleInfo');
    if (encodedVal != null) {

      this.uInfo = JSON.parse(atob(encodedVal));

      let userRoleInfo: UserLogin = JSON.parse(atob(encodedVal));

      let storedVendor = this.storageService.getItem<any>("selectedVendor");
      this.vendorId = storedVendor.vendorID;

      this.categoryList = userRoleInfo.categories;
      this.categoryList = this.categoryList.map((x: any) => ({ 'label': x.categoryName, 'value': x.categoryID }));

      this.userCategoryList = userRoleInfo.userCategory;

      if (this.userRoleService.role?.roleID == 4 || this.userRoleService.role?.roleID == 1) {
        this.selectedCategories = this.userCategoryList.map(a => a.categoryID);
      } else {
        this.selectedCategories = this.categoryList.map(a => a.value);
      }
    }
  }

  saveStoreCoverage() {
    if (!this.storeCoverageData) {
      this.msgService.htmlError("Invalid data.");
      return;
    }

    const errorMessages: string[] = [];

    if (!this.storeCoverageData?.title) {
      errorMessages.push("Please Enter Title.");
    }

    if (!this.storeCoverageData?.category || this.storeCoverageData?.category == 0) {
      errorMessages.push("Please Select Category.");
    }

    if (!this.storeCoverageData.storeCoverageDate) {
      errorMessages.push("Please Select Date.");
    }

    if (this.selectedAction == 'ADD' && (!this.files || this.files.length === 0)) {
      errorMessages.push("Please upload a file before saving.");
    }

    if (this.selectedAction == 'EDIT' && this.storeCoverageData.fileName === '') {
      errorMessages.push("Please upload a file before saving.");
    }

    if (errorMessages.length > 0) {
      this.msgService.htmlError(errorMessages.join('<br>'));
      return;
    }

    // Check for changes only in EDIT mode
    if (this.selectedAction === 'EDIT') {
      const hasChanges =
        this.storeCoverageData.title !== this.originalStoreCoverage?.title ||
        this.storeCoverageData.category !== this.originalStoreCoverage?.category ||
        moment(this.storeCoverageData.storeCoverageDate).format('YYYY-MM-DD') !==
        moment(this.originalStoreCoverage?.storeCoverageDate).format('YYYY-MM-DD') ||
        (this.files?.length > 0); // new file uploaded

      if (!hasChanges) {
        this.msgService.htmlWarning("No Changes for Edit Action");
        return;
      }
    }

    if (this.selectedAction === 'EDIT') {
      this.storeCoverageData.updatedBy = this.uInfo?.userID ?? 0;
    } else {
      this.storeCoverageData.createdBy = this.uInfo?.userID ?? 0;
    }

    if (this.files?.length > 0) {
      this.storeCoverageData.fileName = this.files[0].name;
      this.storeCoverageData.base64String = this.files[0].base64;
    }

    const momentDate = moment(this.storeCoverageData.storeCoverageDate, 'YYYY-MM-DD').toDate();
    this.storeCoverageData.storeCoverageDate = momentDate;
    this.storeCoverageData.storeCoverageDateStr = moment(this.storeCoverageData.storeCoverageDate).format('DD-MMM-yyyy');

    console.log(this.storeCoverageData);

    let successMag = this.selectedAction == 'ADD' ? "Store Coverage saved successfully" : "Store Coverage updated successfully";

    this.ngxService.start();

    this.projectService.saveStoreCoverage(this.storeCoverageData).subscribe({
      next: () => {
        this.msgService.htmlSuccess(successMag);
        this.clearStoreCoverage();
        this.saveSuccess.emit();
        this.ngxService.stop();
      },
      error: (err) => {
        this.msgService.htmlError("Error saving Store Coverage: " + err.message);
        this.ngxService.stop();
      }
    });

  }

  clearStoreCoverage(): void {
    this.files = [];
    this.resetFileInput();
    this.storeCoverageData = new StoreCoverage();
    this.storeCoverageData.fileName = '';
    this.storeCoverageData.base64String = '';
    this.storeCoverageData.category = 0;
  }

  async onFilesSelected(event: any) {
    const selectedFiles = event.target.files;
    this.files = [];

    const file = selectedFiles[0];
    if (file) {
      const fileSizeInMB = file.size / (1024 * 1024);
      // Max File Size - 100 MB
      if (fileSizeInMB > 100) {
        this.files = [{ name: 'Invalid', base64: '' }];
        this.resetFileInput();
        return;
      }

      const base64String = await this.convertToBase64(file);
      this.files = [{ name: file.name, base64: base64String }];
      this.storeCoverageData!.fileName = file.name;
      this.storeCoverageData!.base64String = base64String;
      this.resetFileInput();
    }
  }

  convertToBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64 = (reader.result as string).split(',')[1]; // Remove data URL prefix
        resolve(base64);
      };
      reader.onerror = () => reject('Error reading file');
      reader.readAsDataURL(file);
    });
  }

  onDelete(): void {
    this.clearFileDetails();
  }

  clearFileDetails(): void {
    this.files = [];
    this.resetFileInput();
    this.storeCoverageData!.fileName = '';
    this.storeCoverageData!.base64String = '';
  }

  public resetFileInput(): void {
    const fileInput = this.fileInput.nativeElement as HTMLInputElement;
    if (fileInput) {
      fileInput.value = '';
    }
  }

  canDeactivate(): boolean {
    if (this.unsavedChangesService.hasUnsaved) {
      return confirm('You have unsaved changes! Are you sure you want to discard them?');
    }
    return true;
  }

  ngOnDestroy() {
    this.unsavedChangesService.setUnsavedChanges(false);
  }

  onAnyFieldValueChange(e: boolean) {
    if (e) {
      this.unsavedChangesService.setUnsavedChanges(true);
    }
  }

  stopPropagation(event: Event) {
    event.stopPropagation();
  }
}
